// extracted by mini-css-extract-plugin
export default {"container":"Canvas_container__HIuLt"};